const Features = () => {
  const features = [
    {
      title: "Global University Network",
      description: "Access to top universities across South Korea.",
      icon: "🌍",
    },
    {
      title: "Streamlined Applications",
      description:
        "Simplified application process with expert guidance at every step.",
      icon: "📝",
    },
    {
      title: "Scholarship Opportunities",
      description:
        "Find and apply for scholarships that match your academic profile.",
      icon: "🎓",
    },
    {
      title: "Visa Support",
      description:
        "Complete visa guidance and documentation support for international students.",
      icon: "✈️",
    },
    {
      title: "Academic Counseling",
      description:
        "Personalized counseling to match you with the right program and university.",
      icon: "💡",
    },
    {
      title: "Post-Admission Support",
      description:
        "Continuous support even after admission, including accommodation and integration.",
      icon: "🤝",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Raah Global?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive support throughout your international
            education journey, making global education accessible and
            achievable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow duration-200"
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
